module.exports = __webpack_public_path__ + "static/media/puff.78b60cdb.svg";